import Konva from 'konva'

const defaultContent = {
  key: '#KEY',
  value: '#VALUE',
  unit: '#UNIT'
}

const DEFAULT_COLOR = '#fff'
const PADDING = 4
const GAP = 30

const BG_WIDTH = 170
const BG_HEIGHT = 18

export function loadMonitorParameter (row, addNodeEvent = (node) => {}) {
  row.findOne('.background').draggable(false)
  addNodeEvent(row.findOne('.dataKey'))
  addNodeEvent(row.findOne('.dataValue'))
  addNodeEvent(row.findOne('.dataUnit'))
  addNodeEvent(row)
}

export function loadMonitorRow (row, addNodeEvent = (node) => {}) {
  row.findOne('.background').draggable(false)
  addNodeEvent(row.findOne('.monitorKey'))
  addNodeEvent(row.findOne('.monitorValue'))
  addNodeEvent(row.findOne('.monitorUnit'))
  addNodeEvent(row)
}

export function createMonitorParameter (position, addNodeEvent = (node) => {}, name) {
  const row = new Konva.Group({
    name,
    x: position.x,
    y: position.y
  })
  const bg = new Konva.Rect({
    name: 'background',
    x: 0,
    y: 0,
    width: BG_WIDTH,
    height: BG_HEIGHT,
    // fill: 'rgba(249,240,255,0.25)',
    cornerRadius: 3,
    draggable: false
  })
  const key = new Konva.Text({
    name: 'dataKey',
    x: bg.x() + PADDING,
    y: bg.y() + PADDING,
    text: defaultContent.key,
    fill: DEFAULT_COLOR
  })
  const value = new Konva.Text({
    name: 'dataValue',
    x: key.x() + key.width() + GAP,
    y: key.y(),
    text: defaultContent.value,
    fill: DEFAULT_COLOR
  })
  const unit = new Konva.Text({
    name: 'dataUnit',
    x: value.x() + value.width() + GAP,
    y: key.y(),
    text: defaultContent.unit,
    fill: DEFAULT_COLOR
  })
  row.add(bg, key, value, unit)
  addNodeEvent(key)
  addNodeEvent(value)
  addNodeEvent(unit)
  addNodeEvent(row)
  return row
}
